// Author YuJiaBei
// Date 2020-12-17 09:53:12

import * as model from "@/model/em/workflow/EmActProcessStatusModel.js";
import {newEntityStoreHelper} from "@/store/common/entityModule";

function newFilter(paginationFilter = {}) {
    var filter = Object.assign({}, paginationFilter, model.filter)
    return filter;
}

export default newEntityStoreHelper(() => new model.EmActProcessStatus(),newFilter)
    .withStates({
        baseModuleUrl: process.env.VUE_APP_EM_WORKFLOW_URL,
        selectRowsToItems: function (row) {
            return {value: row.code, text: row.name}
        },
    })
    .buildStore()
